// Risk weights for overall score calculation
export const RISK_WEIGHTS = {
  gdpr: 0.4,
  nis2: 0.35,
  dora: 0.25,
};

// Risk level numeric values
export const RISK_VALUES = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

// Sovereignty score weights
export const SOVEREIGNTY_WEIGHTS = {
  nonEU: 60,
  highRisk: 40,
};

// EU countries (ISO 2-letter codes)
export const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
];

// Non-EU providers (for jurisdiction classification)
export const NON_EU_PROVIDERS: Record<string, string> = {
  'AWS': 'US',
  'Amazon Web Services': 'US',
  'Azure': 'US',
  'Microsoft Azure': 'US',
  'Google Cloud': 'US',
  'GCP': 'US',
  'Salesforce': 'US',
  'HubSpot': 'US',
  'Slack': 'US',
  'Zoom': 'US',
  'OpenAI': 'US',
  'Anthropic': 'US',
};

// EU providers
export const EU_PROVIDERS: Record<string, string> = {
  'OVHcloud': 'EU',
  'Scaleway': 'EU',
  'Hetzner': 'EU',
  'Deutsche Telekom': 'EU',
};
